import React from "react";

const PresentationHeader = () => {
  return (
    <>
      <div className="page-header header-filter" filter-color="black">
        <div
          className="rellax-header rellax-header-logo page-header"
          data-rellax-speed="0"
        >
          <div
            className="page-header-image page-header-cover"
            style={{
              backgroundImage:
                "url(" +
                require("../../assets/img/pexels-snapwire-618612.jpg").default +
                ")",
            }}
          ></div>
        </div>

        <div className="rellax-text-container rellax-text">
          <img
            alt="..."
            src={
              require("../../assets/img/13244073_1277572828922843_1571284068826816752_o-removebg-preview (1).png")
                .default
            }
          ></img>
        </div>
      </div>
    </>
  );
};

export default PresentationHeader;
